import { render, staticRenderFns } from "./AttentionBadge.vue?vue&type=template&id=02c0371e&scoped=true&"
import script from "./AttentionBadge.vue?vue&type=script&lang=ts&"
export * from "./AttentionBadge.vue?vue&type=script&lang=ts&"
import style0 from "./AttentionBadge.vue?vue&type=style&index=0&id=02c0371e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c0371e",
  null
  
)

export default component.exports